/** Phone check as a hook, so components can make their own layout call.
 * Live, not one-shot — rotating the device must restore the desktop layout.
 *
 * Lives in lib/ because three features use it (lead drawer, deal sections,
 * SOW): a shared hook must not force feature A to import feature B just to
 * know how wide the screen is.
 */
import { useEffect, useState } from "react";

export function usePhone(): boolean {
  const [p, setP] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(max-width: 720px)").matches);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(max-width: 720px)");
    const on = () => setP(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return p;
}

/** Tap-to-edit cell: when a read row turns into an input, focus it — the tap
 *  meant "edit this", and demanding a second tap on the fresh input is the
 *  kind of small insult that makes a phone UI feel broken. */
export const focusOnMount = (el: HTMLDivElement | null): void => {
  if (el && !el.dataset["autofocused"]) {
    el.dataset["autofocused"] = "1";
    (el.querySelector("input,select") as HTMLElement | null)?.focus();
  }
};
